import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import seemeLogo from '../../../assets/seemelogo.png';

const SeemeSMSSendNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  const recipientMode = data.config?.recipientMode || 'single';
  const toNumber = data.config?.to || '';
  const customerGroupId = data.config?.customerGroupId || '';
  const message = data.config?.message || '';
  const messagePreview = message.length > 30 ? message.substring(0, 30) + '...' : message;
  
  const isBulkMode = recipientMode === 'group' && customerGroupId;

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-red-400 to-red-500 border-2 transition-all duration-200 ${
      selected ? 'border-red-600 shadow-xl scale-105' : 'border-red-300'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center p-1">
            <img src={seemeLogo} alt="Seeme.hu" className="w-full h-full object-contain" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-red-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          {/* SMS details */}
          {isBulkMode ? (
            <div className="flex items-center mt-1 space-x-2">
              <span className="text-xs text-red-100 font-semibold">
                👥 Tömeges küldés (csoport)
              </span>
            </div>
          ) : toNumber ? (
            <div className="flex items-center mt-1 space-x-2">
              <span className="text-xs text-red-100">
                📱 {toNumber}
              </span>
            </div>
          ) : null}
          
          {messagePreview && (
            <div className="text-xs text-red-100 mt-1 truncate">
              💬 {messagePreview}
            </div>
          )}
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-yellow-500' : 'bg-red-300'
          }`} />
        </div>
      </div>

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-900 bg-opacity-30 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Execution result */}
      {data.executionData?.sent && (
        <div className="mt-2 text-xs text-red-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <strong>SMS elküldve:</strong> {data.executionData.messageId || 'Sikeres'}
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 bg-red-600 border-2 border-white"
      />

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-red-600 border-2 border-white"
      />
    </div>
  );
};

export default SeemeSMSSendNode;
